import { Paragraph } from '@welbe/web-design-system';
import { Status } from 'App/Components/Status/Status';
import { Container, Item, Wrapper } from './TraffcLights.styles';

type TrafficLightsProps = {
	data: {
		high: number;
		medium: number;
		low: number;
	};
	onChangeFilters: (filter: { [key: string]: string | null }) => void;
	onSearch: () => void;
};

export const TrafficLights = ({
	data,
	onChangeFilters,
	onSearch,
}: TrafficLightsProps) => {
	const handleClick = (riskLevel: string) => {
		onChangeFilters({ riskLevel });
		onSearch();
	};

	return (
		<Wrapper>
			<Item onClick={() => handleClick('high')}>
				<Container>
					<Status key="high" status="high" hideLabel />
					<Paragraph fontWeight="500">Riesgo alto</Paragraph>
				</Container>
				<Paragraph fontWeight="600">{data?.high || 0}</Paragraph>
			</Item>
			<Item onClick={() => handleClick('medium')}>
				<Container>
					<Status key="medium" status="medium" hideLabel />
					<Paragraph fontWeight="500">Riesgo medio</Paragraph>
				</Container>
				<Paragraph fontWeight="600">{data?.medium || 0}</Paragraph>
			</Item>
			<Item onClick={() => handleClick('low')}>
				<Container>
					<Status key="low" status="low" hideLabel />
					<Paragraph fontWeight="500">Riesgo bajo</Paragraph>
				</Container>
				<Paragraph fontWeight="600">{data?.low || 0}</Paragraph>
			</Item>
		</Wrapper>
	);
};
